import React from 'react'
import { Actuator } from '../../models/smart-home.model'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { makeStyles } from 'tss-react/mui'
import { Stack, Typography } from '@mui/material'

export const useActuatorBaseStyles = makeStyles()(theme => ({
  paper: {
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  },
}))

interface Props {
  actuator: Actuator
  children: React.ReactElement
  breakOnMobile?: boolean
}

const ActuatorBase: React.FC<Props> = ({ actuator, children, breakOnMobile = false }) => {
  const { classes } = useActuatorBaseStyles()

  return (
    <Paper className={classes.paper}>
      <Stack
        flexDirection={breakOnMobile ? { xs: 'column', sm: 'row' } : 'row'}
        gap={2}
        justifyContent="space-between"
        alignItems={breakOnMobile ? { xs: 'flex-start', sm: 'center' } : 'center'}
      >
        <Stack flexDirection={'row'} gap={2} alignItems="center" flexWrap={'wrap'}>
          <Typography variant="h3">{actuator.name}</Typography>
        </Stack>
        {children}
      </Stack>
    </Paper>
  )
}

export default ActuatorBase
